import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
export default class FeedbackStore {
    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: 'FeedbackStore',
            properties: [
                'feedbacks',
                'feedbackKey',
            ],
        });
    }
    feedbacks = [];
    feedbackKey = [];

    reset = () => {
        this.feedbacks = [];
        this.feedbackKey = [];
    };

    setFeedbacks = async state => {
        runInAction(async () => {
            this.feedbacks = state;
        });
    };

    setFeedbackKey = async state => {
        runInAction(async () => {
            this.feedbackKey = state;
        });
    };
}
